import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { filter } from 'rxjs';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { SheetTemplate } from 'app/modules/settings/sheet-templates/sheet-templates.types';
import { SheetTemplatesService } from 'app/modules/settings/sheet-templates/sheet-templates.service';
import { ConfirmService } from 'app/shared/components/widgets/dialog/confirm/confirm.service';

@Component({
  selector: 'sheet-templates-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SheetTemplatesDetailsComponent extends OnDestroyMixin implements OnInit {
  public sheetTemplate: SheetTemplate;
  public sheetTemplateForm: UntypedFormGroup;

  constructor(
    private readonly _router: Router,
    private readonly _formBuilder: UntypedFormBuilder,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _sheetTemplatesService: SheetTemplatesService,
    private readonly _sheetsTemplatesService: SheetTemplatesService,
    private readonly confirmService: ConfirmService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.buildForm();
    this.fetchSheetTemplate();
  }

  private buildForm(): void {
    this.sheetTemplateForm = this._formBuilder.group({
      name: ['', [Validators.required]],
      description: [''],
    });
  }

  private fetchSheetTemplate(): void {
    this._sheetTemplatesService.sheetTemplate$
      .pipe(untilComponentDestroyed(this))
      .subscribe((sheetTemplate: SheetTemplate) => {
        if (sheetTemplate) {
          this.sheetTemplate = sheetTemplate;
          this.sheetTemplateForm.patchValue(this.sheetTemplate);
        }
        this._changeDetectorRef.markForCheck();
      });
  }

  public save(): void {
    this.sheetTemplate.name = this.sheetTemplateForm.value.name;
    this.sheetTemplate.description = this.sheetTemplateForm.value.description;
    this._sheetTemplatesService.updateSheetTemplate(this.sheetTemplate).pipe(untilComponentDestroyed(this)).subscribe();
  }

  public deleteSheetTemplate(): void {
    this.confirmService
      .openConfirmationModal()
      .pipe(filter((result: boolean) => result))
      .subscribe(() => {
        this._sheetsTemplatesService
          .deleteSheetTemplate(this.sheetTemplate.id)
          .pipe(untilComponentDestroyed(this))
          .subscribe(() => this._router.navigate(['../'], { relativeTo: this._activatedRoute }));
      });
  }
}
